class CurrencyEditController {
  /*@ngInject*/
  constructor(
    Auth,
    $state,
    User,
    CurrencyService,
    Modal,
    $translate,
    $stateParams
  ) {
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = CurrencyService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.hasACL = {};

    this.model = {
      id: "",
      name: "",
      symbol: "",
      decimals: 2,
      sortOrder: 1,
      loading: true,
    };
    this.loading = false;
    this.originalId = "";
    this.branchId = this.User.getUser().branchId;
  }

  $onInit() {
    this.loadCurrencyDetails();
  }

  loadCurrencyDetails() {
    const currencyId = this.$stateParams.id;
    this.originalId = currencyId;

    this.Service.details(currencyId)
      .then((data) => {
        this.model = {
          ...data,
          loading: false,
        };
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.Modal.errorModal(err.data.message);
      });
  }

  reset() {
    this.loadCurrencyDetails();
    this.clearErrors();
  }

  clearErrors() {
    this.errors = {};
    this.errorMessage = "";
  }

  submit() {
    this.loading = true;
    this.clearErrors();

    this.Service.update(this.originalId, {
      id: this.model.id,
      name: this.model.name,
      symbol: this.model.symbol,
      decimals: this.model.decimals,
      sortOrder: this.model.sortOrder,
    })
      .then((data) => {
        this.loading = false;
        this.$state.go("currency.all", { page: 1 });
      })
      .catch((err) => {
        this.loading = false;
        if (err && err.data && err.data.errors) {
          err.data.errors.forEach((e) => {
            this.errorMessage += e.message + "<br/>";
          });
        } else if (err && err.data && err.data.error) {
          // Handle single error message from API
          this.errorMessage = err.data.error;
        } else if (err && err.data && err.data.message) {
          this.errorMessage = this.$translate.instant(err.data.message);
        } else {
          this.errorMessage = this.$translate.instant("common.error_occurred");
        }
      });
  }
}

export default CurrencyEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/edit/currency.edit.controller.js